import { ApiResponse, PaginatedResponse } from "../types/common";
import {
  Staff,
  CreateStaffRequest,
  UpdateStaffRequest,
  StaffFilter,
} from "../types/landing";
import api from "./api";

// Staff CRUD Operations
export const staffService = {
  getAllStaff: async (
    filters: StaffFilter = {}
  ): Promise<PaginatedResponse<Staff>> => {
    try {
      const params = new URLSearchParams();

      if (filters.page) params.append("page", filters.page.toString());
      if (filters.limit) params.append("limit", filters.limit.toString());
      if (filters.search) params.append("search", filters.search);
      if (filters.status) params.append("status", filters.status);
      if (filters.department) params.append("department", filters.department);

      const response = await api.get(
        `/landing/staff/admin?${params.toString()}`
      );

      const data = response as any;
      return {
        success: data.success,
        data: data.data || [],
        pagination: {
          currentPage: data.currentPage || 1,
          totalPages: data.totalPages || 1,
          totalItems: data.total || 0,
          hasNext: (data.currentPage || 1) < (data.totalPages || 1),
          hasPrev: (data.currentPage || 1) > 1,
        },
      };
    } catch (error) {
      console.error("Error fetching staff:", error);
      throw error;
    }
  },

  getStaffById: async (id: string): Promise<ApiResponse<Staff>> => {
    try {
      const response = await api.get(`/landing/staff/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error fetching staff by ID:", error);
      throw error;
    }
  },

  createStaff: async (
    staffData: CreateStaffRequest
  ): Promise<ApiResponse<Staff>> => {
    try {
      const response = await api.post("/landing/staff", staffData);
      return response as any;
    } catch (error) {
      console.error("Error creating staff:", error);
      throw error;
    }
  },

  updateStaff: async (
    id: string,
    staffData: UpdateStaffRequest
  ): Promise<ApiResponse<Staff>> => {
    try {
      const response = await api.put(`/landing/staff/${id}`, staffData);
      return response as any;
    } catch (error) {
      console.error("Error updating staff:", error);
      throw error;
    }
  },

  deleteStaff: async (id: string): Promise<ApiResponse<null>> => {
    try {
      const response = await api.delete(`/landing/staff/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error deleting staff:", error);
      throw error;
    }
  },

  activateStaff: async (id: string): Promise<ApiResponse<Staff>> => {
    try {
      const response = await api.patch(`/landing/staff/${id}/activate`);
      return response as any;
    } catch (error) {
      console.error("Error activating staff:", error);
      throw error;
    }
  },

  deactivateStaff: async (id: string): Promise<ApiResponse<Staff>> => {
    try {
      const response = await api.patch(`/landing/staff/${id}/deactivate`);
      return response as any;
    } catch (error) {
      console.error("Error deactivating staff:", error);
      throw error;
    }
  },

  updateStaffOrder: async (
    id: string,
    newOrder: number
  ): Promise<ApiResponse<Staff>> => {
    try {
      const response = await api.patch(`/landing/staff/${id}/order`, {
        displayOrder: newOrder,
      });
      return response as any;
    } catch (error) {
      console.error("Error updating staff order:", error);
      throw error;
    }
  },

  reorderStaff: async (
    items: { id: string; displayOrder: number }[]
  ): Promise<ApiResponse<null>> => {
    try {
      const response = await api.patch(`/landing/staff/reorder`, { items });
      return response as any;
    } catch (error) {
      console.error("Error reordering staff:", error);
      throw error;
    }
  },
};
